import { motion } from "framer-motion";
import { Bell, TrendingUp, Star, Users, IndianRupee } from "lucide-react";

const BARS = [42, 58, 47, 70, 62, 84, 76, 95, 88, 100];

const Stat = ({ icon: Icon, label, value, delta }) => (
  <div className="rounded-xl border border-line bg-white p-3.5">
    <div className="flex items-center gap-2 text-[11px] font-semibold text-muted2"><Icon className="h-3.5 w-3.5 text-sky" />{label}</div>
    <div className="mt-1.5 font-heading text-lg font-bold text-navy">{value}</div>
    <div className="text-[11px] font-semibold text-success">{delta}</div>
  </div>
);

export const HeroMockup = () => (
  <div className="relative mx-auto w-full max-w-[560px] lg:mr-0" data-testid="hero-dashboard-mockup">
    <motion.div initial={{ opacity: 0, y: 30, scale: 0.97 }} animate={{ opacity: 1, y: 0, scale: 1 }} transition={{ duration: 0.7, delay: 0.2 }} className="overflow-hidden rounded-2xl border border-line bg-white shadow-lift">
      <div className="flex items-center gap-2 border-b border-line bg-[#F8FAFC] px-4 py-3">
        <span className="h-3 w-3 rounded-full bg-[#FF5F57]" /><span className="h-3 w-3 rounded-full bg-[#FEBC2E]" /><span className="h-3 w-3 rounded-full bg-[#28C840]" />
        <div className="ml-3 flex-1 truncate rounded-md border border-line bg-white px-3 py-1 text-[11px] text-muted2">app.ownbrandtechnologies.com/dashboard</div>
      </div>
      <div className="p-4 sm:p-5">
        <div className="mb-4 flex items-center justify-between">
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-wider text-muted2">Business Overview</p>
            <p className="font-heading text-base font-bold text-navy">Good morning, Rahul</p>
          </div>
          <span className="rounded-full bg-[#DCFCE7] px-2.5 py-1 text-[11px] font-bold text-success">Live</span>
        </div>
        <div className="grid grid-cols-3 gap-2.5">
          <Stat icon={Users} label="New Leads" value="1,284" delta="+18.2%" />
          <Stat icon={IndianRupee} label="Revenue" value="₹8.4L" delta="+24.6%" />
          <Stat icon={TrendingUp} label="Conversion" value="32%" delta="+6.1%" />
        </div>
        <div className="mt-4 rounded-xl border border-line p-4">
          <div className="mb-3 flex items-center justify-between text-[11px] font-semibold text-muted2"><span>Monthly Growth</span><span className="text-ocean">2026</span></div>
          <div className="flex h-32 items-end gap-2 sm:h-36">
            {BARS.map((h, i) => (
              <motion.div key={i} initial={{ height: 0 }} animate={{ height: `${h}%` }} transition={{ duration: 0.8, delay: 0.5 + i * 0.06, ease: "easeOut" }} className={`flex-1 rounded-t-md ${i === BARS.length - 1 ? "bg-ocean" : "bg-sky"}`} style={{ opacity: 0.55 + i * 0.045 }} />
            ))}
          </div>
        </div>
      </div>
    </motion.div>

    <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.8 }} className="absolute -bottom-8 -left-4 w-[150px] animate-float rounded-[22px] border-[5px] border-navy bg-white p-2.5 shadow-lift sm:-left-10 sm:w-[170px]" data-testid="hero-phone-card">
      <div className="mx-auto mb-2 h-1.5 w-10 rounded-full bg-line" />
      <div className="flex items-center gap-1.5 rounded-lg bg-[#F0F7FC] p-2"><Bell className="h-3.5 w-3.5 text-ocean" /><span className="text-[10px] font-bold text-navy">New lead from Facebook</span></div>
      <div className="mt-2 space-y-1.5">
        {["Priya S. · 3BHK enquiry", "Amit K. · Demo booked", "Neha R. · Paid ₹9,999"].map((t) => (
          <div key={t} className="rounded-md border border-line px-2 py-1.5 text-[9.5px] font-medium text-body">{t}</div>
        ))}
      </div>
    </motion.div>

    <motion.div initial={{ opacity: 0, y: -16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1 }} className="absolute -right-3 -top-6 flex items-center gap-2.5 rounded-2xl border border-line bg-white px-4 py-3 shadow-lift sm:-right-6" data-testid="hero-score-badge">
      <span className="grid h-9 w-9 place-items-center rounded-xl bg-cta"><Star className="h-4 w-4 fill-navy text-navy" /></span>
      <div><p className="font-heading text-lg font-extrabold leading-none text-navy">4.9/5</p><p className="text-[11px] font-semibold text-muted2">Client rating</p></div>
    </motion.div>
  </div>
);
